import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const productAssortmentRBAC = {
  pageID: 'ee13a4122a2919661e8fe4c0c08bab2e',
  elementID: {
    BtnBulkUpload: '797484e9a202431bedb89e6f79697b2d',
    BtnManageLocation: '8203cbb422b8e60db3bceca477d6d69a',
  },
} as const

export const useRBACProductAssortmentPage = createUseRBAC(productAssortmentRBAC.elementID)

export type UseRBACProductAssortmentPageType = ReturnType<typeof useRBACProductAssortmentPage>
